import { cloneDeep } from 'lodash'
import usePerson from '@/hooks/usePerson'
import useProduct from '@/hooks/useProduct'
import { SortUtil } from '@/utils/Sorting'
import { isRequired } from '@/utils/CustomErrors'

// Methods
function getCategory(categoryId = isRequired('categoryId'), personId) {
  const { categories } = useProduct()

  if (personId) {
    return getCategoriesByPersonId(personId).find(c => c.id === categoryId)
  } else {
    return categories.value[categoryId]
  }
}

function getCategoriesByPersonId(personId = isRequired('personId')) {
  const { getPerson } = usePerson()
  const { categories } = useProduct()
  const personCategories = getPerson(personId)?.products?.categories ?? {}

  if (!personCategories) return []

  return getSortedCategories(categories.value)
    .filter(category => !!personCategories[category.id])
    .map(category => Object.assign(category, personCategories[category.id]))
    .sort(SortUtil.sortByOrder)
}

function getGroup(groupId = isRequired('groupId'), personId) {
  const { groups } = useProduct()

  if (personId) {
    return getGroupsByPersonId(personId).find(g => g.id === groupId)
  } else {
    return groups.value[groupId]
  }
}

function getGroupsByPersonId(personId = isRequired('personId')) {
  const { getPerson } = usePerson()
  const { groups } = useProduct()
  const personGroups = getPerson(personId)?.products?.groups ?? {}

  if (!personGroups) return []

  return getSortedGroups(groups.value)
    .filter(group => !!personGroups[group.id])
    .map(group => Object.assign(group, personGroups[group.id]))
    .sort(SortUtil.sortByOrder)
}

/**
 * Returns all categories in an array sorted by order field
 * @param categories
 * @return []
 */
function getSortedCategories(categories = isRequired('categories')) {
  const data = []
  const categoriesCopy = cloneDeep(categories)
  Object.keys(categoriesCopy).forEach(categoryId => data.push(categoriesCopy[categoryId]))
  return data.sort(SortUtil.sortByOrder)
}

function getSortedGroups(groups = isRequired('groups')) {
  const data = []
  const _groups = cloneDeep(groups)
  Object.keys(_groups).forEach(groupId => data.push(_groups[groupId]))
  return data.sort(SortUtil.sortByOrder)
}

export default function useCategories() {
  return {
    getCategory,
    getCategoriesByPersonId,

    getGroup,
    getGroupsByPersonId,

    getSortedCategories,
  }
}
